// extracted by mini-css-extract-plugin
module.exports = {"container":"CardFrame_container__2MDld","backSide":"CardFrame_backSide__34c6J","title":"CardFrame_title__1M38M"};